/* eslint-disable no-useless-escape */
/* eslint-disable no-param-reassign */
import { base64ToBlob, Compress, Device, Emoji } from '@chat/utils';
import { imageTypes, MAX_IMAGE_COUNT, videoTypes, WORD_LIMIT } from '@/config/config';
import store from '@/redux/index';
import { EditorServerImp } from '@/typings/global';
import { imappend } from '@/redux/im/action';

const { getState, dispatch } = store;
class EditorServer implements EditorServerImp {
    /** emoji转换 */
    private emoji: Emoji;

    /** 编辑器标签 */
    private ele: HTMLElement;

    /** 光标最后的位置 */
    private last_range: Range;

    /** setState */
    private _setCount: (value: React.SetStateAction<number>) => void;

    private Device: Device;

    constructor() {
        this.emoji = new Emoji();
        this.ele = null;
        this.last_range = null;
        this._setCount = () => {};
        this.Device = getState().IndexReducer.Device;
    }

    setEditor = (ele: HTMLElement): void => {
        this.ele = ele;
    };

    setFuncCount = (func: React.Dispatch<React.SetStateAction<number>>): void => {
        this._setCount = func;
    };

    funcCount = (async = true): number => {
        const length = this.Device.isMobile
            ? this.emoji.utf16toEntities(this.getHtml()).length
            : this.funcCompute(this.funcContent(this.getHtml()));
        const _count = WORD_LIMIT - length;
        if (async) {
            this._setCount(_count);
        }
        return _count;
    };

    get = (): any => {
        return { last_range: this.last_range, ele: this.ele };
    };

    getHtml = (): string => {
        if (this.Device.isMobile) {
            return $(this.ele).val() as string;
        }
        return $(this.ele).html();
    };

    getImageCount = (html?: string): number => {
        const content = html ?? this.getHtml() ?? '';
        const matchedImages = content.match(/<img\b(?![^>]*data-type=['"]face['"])[^>]*>/gi);
        return matchedImages ? matchedImages.length : 0;
    };

    getEncodedSize = (value: string): number => {
        try {
            return encodeURIComponent(value).length;
        } catch (error) {
            return value.length;
        }
    };

    focus = (): void => {
        this.ele?.focus();
    };

    blur = (): void => {
        this.ele?.blur();
    };

    funcGetRange = (): void => {
        if (this.Device.isMobile) {
            console.warn('not support in wap');
            return;
        }
        if (window.getSelection) {
            const selection = window.getSelection();

            if (selection.rangeCount > 0) {
                const classname = (selection.getRangeAt(0).startContainer as { className?: string })
                    .className;
                // firefox浏览器会在可编辑div之外获取焦点，所以需要增加这个判断
                if ((classname && classname === 'editor-area') || !classname) {
                    this.last_range = selection.getRangeAt(0);
                }
            }
        } else if ((document as any).selection) {
            const range = (document as any).selection.createRange();
            this.last_range = range.getBookmark();
        }
    };

    funcGetEnd = (): void => {
        if (this.Device.isMobile) {
            console.warn('not support in wap');
            return;
        }
        let sel;
        let range;
        if (window.getSelection) {
            sel = window.getSelection();
        } else if (window.document.getSelection) {
            sel = window.document.getSelection();
        } else if ((window as any).document.selection) {
            sel = (window as any).document.selection.createRange().text;
        }
        if (document.createRange) {
            range = document.createRange();
            range.selectNodeContents(this.ele);
            range.collapse(false);
            sel.removeAllRanges();
            sel.addRange(range);
        } else {
            range = (document as any).body.createTextRange();
            (document as any).selection.empty();
            range.moveToElementText(this.ele);
            range.collapse(false);
            range.select();
        }
    };

    funcInsert = (html: string): void => {
        if (this.Device.isMobile) {
            console.warn('not support in wap');
        }
        let sel;
        let range;
        let frag;
        if (window.getSelection) {
            sel = window.getSelection();
        } else if (window.document.getSelection) {
            sel = window.document.getSelection();
        } else if ((window as any).document.selection) {
            sel = (window as any).document.selection.createRange().text;
        }
        if (sel.getRangeAt && sel.rangeCount) {
            if (this.last_range) {
                range = this.last_range;
            } else {
                range = sel.collapseToStart();
                // range.deleteContents();
            }
            // 插入节点元素
            const el = document.createElement('div');
            el.innerHTML = html;
            frag = document.createDocumentFragment();
            let node;
            let lastNode;
            // eslint-disable-next-line no-cond-assign
            while ((node = el.firstChild)) {
                lastNode = frag.appendChild(node);
            }
            range.insertNode(frag);
            // 设置光标到最后一个节点之后
            if (lastNode) {
                range = range.cloneRange();
                range.setStartAfter(lastNode);
                range.collapse(true);
                sel.removeAllRanges();
                sel.addRange(range);
            }
        }
    };

    // eslint-disable-next-line @typescript-eslint/no-shadow
    funcUpload = (send): void => {
        if (this.getImageCount() >= MAX_IMAGE_COUNT) {
            IM.Toast.error({
                content: `单次最多发送${MAX_IMAGE_COUNT}张图片`
            });
            return;
        }
        const { is_support_file } = IM.SDKServer.getState();
        const _this = this;
        const _uploader = document.createElement('input');
        _uploader.type = 'file';
        _uploader.style.display = 'none';
        _uploader.accept = is_support_file
            ? imageTypes.filter((type) => type !== '.gif').join(',')
            : 'image/*';
        document.body.appendChild(_uploader);
        _uploader.onchange = function () {
            const reader = new FileReader();
            const _file = (this as any).files[0];
            const suffix = /[^\.]\w*$/.exec(_file.name)[0];
            if (!_.includes(imageTypes, `.${suffix.toLocaleLowerCase()}`)) {
                IM.Toast.error({ content: '格式不正确' });
                return;
            }
            reader.readAsDataURL(_file);
            reader.onload = function (e) {
                // 图片压缩
                Compress(
                    (e.target as FileReader).result as string,
                    1920,
                    1080,
                    0.8,
                    function (base64, type) {
                        const blob = _this.Device.isMobile ? _file : base64ToBlob(base64);
                        if (type === 'gif') {
                            if (blob.size > 2 * 1024 * 1024) {
                                IM.Toast.error({ content: 'GIF图大小不能超过2M' });
                                return;
                            }
                        }
                        if (blob.size > 8 * 1024 * 1024) {
                            IM.Toast.error({ content: '图片大小不能超过8M' });
                            return;
                        }
                        const html = `<img data-name="${_file.name}" src="${base64}" data-src="src" data-type='image'>`;
                        if (_this.Device.isMobile) {
                            send(html, _file);
                        } else {
                            if (!_this.last_range) {
                                _this.ele.focus();
                                _this.funcGetRange();
                            }
                            _this.funcInsert(html);
                            _this.funcCount();
                        }
                        document.body.removeChild(_uploader);
                    },
                    function (type) {
                        IM.Toast.error({ content: '暂不支持该类型图片' });
                    }
                );
            };
        };
        _uploader.click();
    };

    funcUploadVideo = (): void => {
        const { is_support_file } = IM.SDKServer.getState();
        const _uploader = document.createElement('input');
        _uploader.type = 'file';
        _uploader.style.display = 'none';
        _uploader.accept = is_support_file ? videoTypes.join(',') : 'video/*';
        _uploader.addEventListener('change', async (event) => {
            const _file = _uploader.files[0];
            const suffix = /[^\.]\w*$/.exec(_file.name)[0];
            if (!_.includes(videoTypes, `.${suffix.toLocaleLowerCase()}`)) {
                IM.Toast.error({ content: '文件格式不正确' });
                return;
            }
            if (_file.size > 500 * 1024 * 1024) {
                IM.Toast.error({ content: '文件大小不能超过500M' });
                return;
            }
            imappend({
                message: _file,
                type: 'out',
                msg_type: '_video'
                // ctx: { key: `${dayjs().valueOf()}` }
            })(dispatch, getState);
            document.body.removeChild(_uploader);
        });
        document.body.appendChild(_uploader);
        _uploader.click();
    };

    funcCompute = (html: string): number => {
        html = html.replace(/<(img)[^>]*>/gi, '****');
        html = html.replace(/<[^>]*?>/gi, '');
        html = html.replace(/&(\w+);/gi, ' ');
        html = html.replace(/[\n]+/gi, '');
        return html.length;
    };

    funcFilter = (origin: string): string => {
        origin = origin.replace(/<!--[\s\S]*?-->/gi, '');
        origin = origin.replace(/\n/g, '');
        origin = origin.replace(/<\/\s*(div|p|h\d|dl|dd|dt|ul|li)\s*>/gi, '\n');
        origin = origin.replace(
            /<(iframe|style|script|frame|object|audio|sound)[^>]*>.*?<\s*\/\s*\1\s*>/gi,
            ''
        );
        origin = origin.replace(/<(?!img|br)[^>]*>/gi, '');
        // 去除行内style
        origin = origin.replace(/style\s*?=\s*?(['"])[\s\S]*?\1/gi, '');
        origin = origin.replace(/\n\s*\n/gi, '\n');
        origin = _.trim(origin);
        return origin;
    };

    funcContent = (html: string): string => {
        html = html.replace(/&nbsp;/gi, '');
        // Apple 系浏览器/编辑器自动插入的换行标记
        html = html.replace(/<br class="Apple-interchange-newline">/g, '<br>');
        html = html.replace(new RegExp('<br\\s*\\/?>', 'gi'), '\n');
        html = html.replace(new RegExp('<div>\\s*</div>', 'gi'), '\n');
        html = html.replace(new RegExp('<p>\\s*</p>', 'gi'), '\n');
        html = html.replace(new RegExp('[\\n\\r]+', 'gi'), '\n');
        html = html.replace(new RegExp('(^\\s+|\\s+$)', 'gi'), '');
        // 移动端emoji转换
        html = this.emoji.utf16toEntities(html);
        return html || '';
    };

    funcResetArea = (): void => {
        if (this.Device.isMobile) {
            $(this.ele).val('');
            $(this.ele).css('height', `${window?.IMBridge?.mobileTextAreaHeight || 0.9375}rem`);
        } else {
            $(this.ele).html('');
        }
    };
}

export default EditorServer;
